var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDatepickerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4527 3.51289H11.1738V2.71429C11.1738 2.59591 11.0765 2.5 10.9564 2.5H10.5224C10.4024 2.5 10.3051 2.59591 10.3051 2.71429V3.5128H5.6949V2.71429C5.6949 2.59591 5.59762 2.5 5.47756 2.5H5.04357C4.92351 2.5 4.82623 2.59591 4.82623 2.71429V3.5128H3.54584C2.92912 3.51409 2.42784 4.0096 2.42871 4.6168V12.251V13.3969C2.42871 14.0061 2.92964 14.5 3.54758 14.5H8.25117H11.2905H12.454C13.0711 14.4991 13.5724 14.0041 13.5716 13.396V8.75671V6.73317V5.8768V4.61594C13.5715 4.00677 13.0706 3.51289 12.4527 3.51289ZM12.7029 8.75671V13.3963C12.7029 13.4623 12.677 13.5243 12.63 13.5711C12.5824 13.6176 12.5193 13.6435 12.4527 13.6435H11.2905H8.25117H3.54749C3.40961 13.6435 3.2972 13.5322 3.2972 13.3958V12.2509V6.73317H12.7028L12.7029 8.75671ZM3.2972 5.8768V4.61637C3.2972 4.48043 3.40961 4.3696 3.54749 4.36917H4.82632H5.69499H10.3053H11.1739H12.4528C12.5907 4.36917 12.7031 4.48043 12.7031 4.6168V5.8768H3.2972Z",
    fill: "#515C7D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatepickerIcon);
export default __webpack_public_path__ + "static/media/DatepickerIcon.e24ed00ee19b616a37f46c7a951525b9.svg";
export { ForwardRef as ReactComponent };